var _style, _polygon, _g, _g2, _polygon2, _polygon3, _g3, _g4, _polygon4, _polygon5, _polygon6, _polygon7, _g5, _polygon8, _polygon9, _polygon0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetaMask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 237.4",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E2761B;stroke:#E2761B;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:#E4761B;stroke:#E4761B;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:#D7C1B3;stroke:#D7C1B3;stroke-linecap:round;stroke-linejoin:round;}\n\t.st3{fill:#233447;stroke:#233447;stroke-linecap:round;stroke-linejoin:round;}\n\t.st4{fill:#CD6116;stroke:#CD6116;stroke-linecap:round;stroke-linejoin:round;}\n\t.st5{fill:#E4751F;stroke:#E4751F;stroke-linecap:round;stroke-linejoin:round;}\n\t.st6{fill:#F6851B;stroke:#F6851B;stroke-linecap:round;stroke-linejoin:round;}\n\t.st7{fill:#C0AD9E;stroke:#C0AD9E;stroke-linecap:round;stroke-linejoin:round;}\n\t.st8{fill:#161616;stroke:#161616;stroke-linecap:round;stroke-linejoin:round;}\n\t.st9{fill:#763D16;stroke:#763D16;stroke-linecap:round;stroke-linejoin:round;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    transform: "translate(-31.3 -35)",
    points: "174.6 109.4 193 65.8 274.1 35.5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-31.3 -35)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "143.1 110.1 125.6 65.8 44.4 35.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "284.8 207.7 238.3 206.8 211.8 247.4 268.5 263"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "80.3 206.8 33.9 207.7 50.1 263 106.8 247.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "142.1 104.1 103.6 138.2 87.8 162.1 144.1 164.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "230.8 162.1 214.9 138.2 175.9 103.4 174.6 164.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "140.6 230.9 111.4 208.1 106.8 247.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "211.8 247.4 207.1 208.1 177.9 230.9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-31.3 -35)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "180.3 262.3 211.8 247.4 177.9 230.9 180.6 253"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "140.6 230.9 106.8 247.4 138.3 262.3 138.1 253"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    transform: "translate(-31.3 -35)",
    points: "110.6 185.2 130.5 176.1 138.8 193.5"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    transform: "translate(-31.3 -35)",
    points: "188 176.1 208 185.2 179.7 193.5"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-31.3 -35)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "111.6 206.8 80.3 207.7 106.8 247.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "211.8 247.4 238.3 207.7 207 206.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.6 164.6 179.8 193.5 188.1 176.1 208.1 185.2 230.8 162.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "130.6 176.1 138.8 193.5 144.1 164.6 87.8 162.1 110.6 185.2"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-31.3 -35)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "111.4 208.1 110.6 185.2 87.8 162.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "207.1 208.1 230.8 162.1 208.1 185.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "146.9 182.7 144.1 164.6 138.8 193.5 145.4 227.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "179.8 193.5 174.6 164.6 171.9 182.6 173.1 227.6"
  }))), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    transform: "translate(-31.3 -35)",
    points: "173.1 227.6 177.9 230.9 207.1 208.1 208.1 185.2 179.8 193.5"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    transform: "translate(-31.3 -35)",
    points: "111.4 208.1 140.6 230.9 145.4 227.6 138.8 193.5 110.6 185.2"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    transform: "translate(-31.3 -35)",
    points: "117.8 256.4 140.1 271.9 178.4 271.9 200.8 256.4 211.8 247.4 180.3 262.3 180.6 253 178.1 250.8 140.4 250.8 138.1 253 138.3 262.3 106.8 247.4"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    transform: "translate(-31.3 -35)",
    points: "180.6 253 177.9 230.9 173.1 227.6 145.4 227.6 140.6 230.9 138.1 253 140.4 250.8 178.1 250.8"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-31.3 -35)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "275.6 124.3 283.6 118.2 278.3 114.2 286.8 73.4 274.1 35.5 177.9 106.9 214.9 138.2 267.2 153.5 278.8 140 273.8 136.4 281.8 129.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "140.6 106.9 44.4 35.5 31.8 73.4 40.3 114.2 34.9 118.2 42.9 124.3 36.8 129.1 44.8 136.4 39.8 140 51.3 153.5 103.6 138.2"
  }))), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    transform: "translate(-31.3 -35)",
    points: "214.9 138.2 230.8 162.1 207.1 208.1 238.3 207.7 284.8 207.7 267.2 153.5"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    transform: "translate(-31.3 -35)",
    points: "51.3 153.5 33.9 207.7 80.3 207.7 111.4 208.1 87.8 162.1 103.6 138.2"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    transform: "translate(-31.3 -35)",
    points: "177.9 106.9 193.1 65.8 125.6 65.8 140.6 106.9 144.1 164.6 145.3 182.8 145.4 227.6 173.1 227.6 173.3 182.8 174.6 164.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaMask);
export default __webpack_public_path__ + "static/media/MetaMask.910c823dfc655f3a894c5162bd2d3554.svg";
export { ForwardRef as ReactComponent };